/* eslint-disable import/prefer-default-export */
import { READING_ACTION_TYPES } from './action_types';

/**
 * Updates redux with book's gamestate data
 * @param {object} gameDetails - book's saved gameDetails to store in redux
 */
export const updateLocalBookState = (gameDetails) => ({
  type: READING_ACTION_TYPES.UPDATE_LOCAL_BOOK_STATE,
  payload: { gameDetails },
});
